<template>
<widget class="widget">
	<div v-if="isInstalled" class="alert alert-success install-flag"><i class="fa fa-check"></i> Installed to {{ app.AddonAppInstalled[0].ui_location ? app.AddonAppInstalled[0].ui_location : 'Main Apps Tab' }}</div>
	<div class="row">
		<div class="col-md-3 col-sm-3">
			<div class="d-flex align-items-center bg-light app-logo-box">
				<img v-if="app.logo_src" :src="app.logo_src">
			</div>
		</div>
		<div class="col-md-6 col-sm-9">
			<div class="app-details-box">
				<h2>{{app.app_name}}</h2>

				<div class="description-box"><pre>{{ app.description }}</pre></div>

				<p>By <em>{{ app.developer_name }}</em></p>
			</div>
		</div>
		<div class="col-md-3 col-sm-12">
			<div class="app-controls-box">
				<button v-if="editable" slot="header" class="btn btn-light float-right ml-1" v-on:click="$emit('edit')">
					<i class="fa fa-pencil-alt"></i>
					Re-publish...
				</button>

				<button v-if="editable && showDeleteListing" slot="header" class="btn btn-outline-danger" v-on:click="$emit('deleteListing')">
					<i class="fa fa-trash-alt"></i>
					Delete listing
				</button>

				<button v-if="isInstalled && !hideUninstallButton" slot="header" class="btn btn-light float-right ml-1" v-on:click="$emit('uninstall')">
					<i class="fa fa-toggle-off"></i>
					Uninstall
				</button>
				<template v-if="isInstalled">
					<button v-if="!showMoveLocationSelect" class="btn btn-light ml-1" v-on:click="openMoveLocationSelect">
						<i class="fa fa-exchange-alt"></i>
						Move...
					</button>

					<field v-if="showMoveLocationSelect"
						label="Move to"
						col-class="stacked"
						:params="{type:'select',options:uiLocations}"
						v-model="moveLocation"
						v-on:change="moveTo">
					</field>

					<field
						label="Show in Top Bar"
						col-class="stacked"
						:params="{type:'boolean'}"
						v-model="inTopMenu"
						v-on:change="toggleInTopMenu">
					</field>

					<field
						label="Show in Side Menu"
						col-class="stacked"
						:params="{type:'boolean'}"
						v-model="inSideMenu"
						v-on:change="toggleInSideMenu">
					</field>

					<field
						label="API Permissions"
						col-class="stacked"
						:params="{type:'select', options: tokenPermissionOptions}"
						v-model="tokenIsReadonly"
						v-on:change="saveTokenIsReadonly">
					</field>
				</template>
				<template v-if="!isInstalled && !hideInstallButton">
					<button v-if="!showInstallLocationSelect" style="position: relative;top: -1px" class="btn btn-success ml-1" v-on:click="showInstallLocationSelect = true">
						<i class="fa fa-toggle-on"></i>
						Install
					</button>

					<field v-if="showInstallLocationSelect" 
						label="Install to"
						col-class="stacked"
						:params="{type:'select',options:uiLocations}"
						v-model="installLocation"
						v-on:change="installTo">
					</field>
				</template>
			</div>
		</div>
	</div>

	<div class="meta-box bg-light">
		<table>
			<tr>
				<th>Last Published:</th>
				<td>{{ moment.utc(app.publish_date).local().format("MMM D, YYYY") }} <em>version {{ app.app_version }}</em></td>
			</tr>
		</table>
		<div v-if="app.support_website"><a :href="app.support_website" target="_blank"><i class="fa fa-external-link-alt"></i> More Details & Support</a></div>
		<div class="row">

			<div class="col-md-8">
				
			</div>
			<div class="col-md-4">
				
			</div>
		</div>
	</div>

</widget>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import Widget from "@/components/Widget"

export default {
	components: {
		Widget,
		Field
	},
	props: ["app","isInstalled","editable","hideUninstallButton","hideInstallButton","showDeleteListing"],
	data() {
		return {
			installLocation: "",
			showInstallLocationSelect:false,
			moveLocation: "",
			showMoveLocationSelect: false,
			inTopMenu: 0,
			inSideMenu: 0,
			tokenIsReadonly: "full",
			tokenPermissionOptions: [
				{text: "Full Permissions", value: "full"},
				{text: "Read Only", value: "readonly"}
			],
			uiLocations: [
				'Main',
				'Dashboard',
				'Dashboard Widget',
				'Projects Module',
				'Project Record',
				'Services Module',
				'Service Record',
				'Equipment Module',
				'Health & Safety Module',
				'Contacts Module',
				'Materials Module',
				'Employees Module',
				//'Expenses Module',
				//'Time Logs Module',
				//'Library Module'
			],

		}
	},
	watch: {
		app: {
			immediate: true,
			handler() {
				if (this.app.AddonAppInstalled && this.app.AddonAppInstalled[0]) {
					this.inTopMenu = this.app.AddonAppInstalled[0].in_top_menu
					this.inSideMenu = this.app.AddonAppInstalled[0].in_side_menu
					if (this.app.AddonAppInstalled[0].token_is_readonly == 1)
						this.tokenIsReadonly = "readonly"
					else
						this.tokenIsReadonly = "full"
				}
				else {
					this.inTopMenu = 0
					this.inSideMenu = 0
					this.tokenIsReadonly = "full"
				}
			}
		}
	},
	methods: {
		currentInstallLocation() {
			if (this.app.AddonAppInstalled && this.app.AddonAppInstalled[0] && this.app.AddonAppInstalled[0].ui_location)
				return this.app.AddonAppInstalled[0].ui_location

			return 'Main'
		},
		openMoveLocationSelect() {
			this.moveLocation = this.currentInstallLocation()
			this.showMoveLocationSelect = true
		},
		installTo(installLocation) {
			this.$emit('install',this.app.id,installLocation)
		},
		moveTo(uiLocation) {
			if (!uiLocation)
				return

			if (uiLocation == this.currentInstallLocation())
				return

			this.$emit('uiLocationChange', uiLocation)
			this.showMoveLocationSelect = false
		},
		toggleInTopMenu(value) {
			this.inTopMenu = value
			this.$emit('inTopMenuChange', value)
		},
		toggleInSideMenu(value) {
			this.inSideMenu = value
			this.$emit('inSideMenuChange', value)
		},
		saveTokenIsReadonly(value) {
			this.tokenIsReadonly = value
			if (value == "readonly")
				this.$emit('tokenIsReadonlyChange', 1)
			else
				this.$emit('tokenIsReadonlyChange', 0)
		}
	}
}
</script>

<style type="text/css" scoped>
	pre {
		font-family: inherit;
		font-size: inherit;
		white-space: pre-wrap;
	}

	.widget {
		margin-left: 7px;
		margin-right: 7px;
	}

	.install-flag {
		margin: -9px;
		margin-top: -19px;
		margin-bottom: 10px;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		padding: 2px;
		padding-left: 10px;
	}

	.app-logo-box {
		width: 150px;
		height: 150px;
		padding: 20px;
		flex-basis: 150px;
		flex-grow: 0;
		flex-shrink: 0;
		margin: auto;
		margin-bottom: 20px;
	}

	.app-controls-box {
		display: flex;
		flex-direction: column;
		width: 100%;
		flex-basis: 180px;
		flex-grow: 0;
		flex-shrink: 0;
		padding-right: 8px;
	}

	.app-controls-box>* {
		width: 100%;
	}

	.app-details-box {
		padding-left: 20px;
		padding-right: 20px;
		flex-grow: 1

	}

	.description-box {
		min-height: 100px;
	}

	.meta-box {
		margin-top: 10px;
		margin-left: -7px;
		margin-right: -7px;
		margin-bottom: -7px;
		padding: 10px;
	}
</style>